(function(){
    'use strict';
    angular.module('app').config(routesUrlConfig);

    routesUrlConfig.$inject = ['$routeProvider', '$locationProvider'];

    function routesUrlConfig($routeProvider, $locationProvider) {
        $routeProvider.
        when('/jobs', {
            templateUrl: '/templates/pages/jobs/jobs.html',
            controller: 'JobsController',
            controllerAs: 'vm',
            params: {
                parent: 'jobs',
                subParent: 'jobs',
                htmlTitle: 'Jobs Management',
                pageTitle: 'Jobs Management',
                icon: 'fa fa-home'
            }
        }).
        when('/jobs/details/:id', {
            templateUrl: '/templates/pages/jobs/jobs-details.html',
            controller: 'JobsDetailsController',
            controllerAs: 'vm',
            params: {
                parent: 'jobs',
                subParent: 'jobs',
                htmlTitle: 'Job Management',
                pageTitle: 'Job Management',
                icon: 'fa fa-home'
            }
        })
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }
})();


// WEBPACK FOOTER //
// ./js/urls/jobs.js